<script lang="ts" setup>
import { historyCommonConfig as config, historyDeleteModalTheme } from './configs/common'
import HistoryPageDefault from './components/HistoryPage.default.vue'
import HistoryPageFlipnovel from './components/HistoryPage.flipnovel.vue'
import HistoryPageNovelyn from './components/HistoryPage.novelyn.vue'
import HistoryPageNovelmello from './components/HistoryPage.novelmello.vue'
import { loadBrandComponent } from '@/utils/loadBrandConfig'

const HistoryPage = loadBrandComponent({
  rocnovel: HistoryPageDefault,
  oceread: HistoryPageDefault,
  talewave: HistoryPageDefault,
  ficmoon: HistoryPageDefault,
  novelarc: HistoryPageDefault,
  storyella: HistoryPageDefault,
  aurenovel: HistoryPageDefault,
  silktale: HistoryPageDefault,
  pearla: HistoryPageDefault,
  fictora: HistoryPageDefault,
  marinovel: HistoryPageDefault,
  flipnovel: HistoryPageFlipnovel,
  moonpage: HistoryPageFlipnovel,
  novelune: HistoryPageFlipnovel,
  storlyn: HistoryPageFlipnovel,
  novaris: HistoryPageFlipnovel,
  novelyn: HistoryPageNovelyn,
  novelmello: HistoryPageNovelmello,
  novelsprig: HistoryPageDefault,
})
</script>

<template>
  <HistoryPage :config="config" :delete-modal-theme="historyDeleteModalTheme" />
</template>
